'use strict';

class ChallengesDemandController {
  constructor($q,
              $scope,
              $filter,
              $state,
              utils,
              config,
              DevicesService,
              ChallengesService,
              ToastsService,
              I18nService) {

    const $t = $filter('translate');
    const locale = I18nService.getLocale()?.code || 'en';
    const CURRENT_ORG_LOCAL_STORAGE_KEY = 'Organizations-Current';

    $scope.orgInfo = utils.getStorageItem(CURRENT_ORG_LOCAL_STORAGE_KEY);
    $scope.challengeId = $state.params && $state.params.id;

    // $scope.optInStatuses = config.getConfigByKey("optInStatuses");
    $scope.deviceTypeExistance = config.getConfigByKey('deviceTypeExistance');
    $scope.thermostats = config.getConfigByKey('thermostats');

    // Navigation Tabs
    $scope.tabs = [
      {
        id: 'status',
        name: $t('form.status'),
        icon: 'far fa-file-alt'
      },
      {
        id: 'participants',
        name: $t('challenges.users'),
        icon: 'iotr fa-friends'
      },
    ];

    // Start Max Energy Savings
    let currentDate = new Date();
    $scope.currentDateMs = currentDate.getTime();

    // Datepicker Options
    let defaultDatePickerOptions = {
      language: locale,
      position: 'bottom left',
      autoClose: true
    };
    let defaultDateDatePickerOptions = {
      view: 'days',
      minView: 'days',
      dateFormat: $scope.dateFormat,
      timepicker: true,
      correctValueToMinMax: false
    };
    $scope.startDatePickerOptions = angular.extend({}, defaultDatePickerOptions, defaultDateDatePickerOptions);
    $scope.endDatePickerOptions = angular.extend({}, defaultDatePickerOptions, defaultDateDatePickerOptions);

    function setDatepickerMinAndMaxDate(options, minDate, maxDate) {
      options.minDate = minDate || '';
      options.maxDate = maxDate || '';
    }

    $scope.$watch('challenge.startDateMs', function(value) {
      if (value) {
        setDatepickerMinAndMaxDate($scope.endDatePickerOptions, new Date(value), null);
      } else {
        setDatepickerMinAndMaxDate($scope.endDatePickerOptions, null, null);
      }
    });

    $scope.$watch('challenge.endDateMs', function(value) {
      if (value) {
        setDatepickerMinAndMaxDate($scope.startDatePickerOptions, null, new Date(value));
      } else {
        setDatepickerMinAndMaxDate($scope.startDatePickerOptions, null, null);
      }
    });

    let initDatePicker = function() {
      $scope.datePickerOptions = {
        language: locale,
        position: 'top left',
        view: 'days',
        minView: 'days',
        dateFormat: 'm/dd/yyyy ',
        timepicker: true,
        autoClose: false,
        minDate: new Date()
      };
    };

    initDatePicker();

    $scope.deleteChallenge = function() {
      return ChallengesService.deleteChallenge($scope.orgInfo.id, $scope.challengeId)
        .then(function(data) {
          $state.go('main.challenges.list');
          return data;
        });
    };

    $scope.changeStatus = function() {
      const status = 0;
      return ChallengesService
        .updateChallengeStatus($scope.orgInfo.id, $scope.challengeId, status)
        .then(function(data) {
          $scope.challenge.status = status;
          return data;
        });
    };

    //save challenge
    let dateCompareRule = function(value) {
      if ($scope.challenge.endDateMs && $scope.challenge.startDateMs) {
        return $scope.challenge.endDateMs - $scope.challenge.startDateMs > 0;
      }
      return false;
    };
    let datepickerRule = function(value) {
      if (!value || value == '') {
        return false;
      }
      return true;
    };
    $.fn.form.settings.rules.startDateRule = function(value) {
      return datepickerRule(value);
    };
    $.fn.form.settings.rules.endDateRule = function(value) {
      return datepickerRule(value);
    };
    $.fn.form.settings.rules.startTimeRule = function(value) {
      return value.match(timeRegExp);
    };
    $.fn.form.settings.rules.endTimeRule = function(value) {
      return value.match(timeRegExp);
    };
    $.fn.form.settings.rules.percentageRule = function(value) {
      if (value < 1 || value > 100) {
        return false;
      } else {
        return true;
      }
    };

    $.fn.form.settings.rules.dateCompareRule = dateCompareRule;

    let updateChallenge = function() {
      let fields = {};
      let challenge = {};
      if ($('[name=\'name\']').is(':visible')) {
        fields['name'] = {
          rules: [
            {
              type: 'empty',
              prompt: $t('prompt.challenges.name.empty')
            }
          ]
        };
      }
      if ($('[name=\'goal\']').is(':visible')) {
        fields['goal'] = {
          rules: [
            {
              type: 'empty',
              prompt: $t('prompt.challenges.goal.empty')
            }
          ]
        };
      }
      if ($('[name=\'date-start\']').is(':visible')) {
        fields['date-start'] = {
          rules: [
            {
              type: 'startDateRule',
              prompt: $t('prompt.challenges.date-start')
            }
          ]
        };
      }
      if ($('[name=\'date-end\']').is(':visible')) {
        fields['date-end'] = {
          rules: [
            {
              type: 'endDateRule',
              prompt: $t('prompt.challenges.date-end')
            }, {
              type: 'dateCompareRule',
              prompt: $t('prompt.challenges.time-end.compare')
            }
          ]
        };
      }
      if ($('[name=\'homes\']').is(':visible')) {
        fields['homes'] = {
          rules: [
            {
              type: 'empty',
              prompt: $t('prompt.challenges.homes.empty')
            }, {
              type: 'percentageRule',
              prompt: $t('prompt.challenges.homes.invalid')
            }
          ]
        };
      }
      $('#form-details').form({
        inline: true,
        fields: fields
      });
      if ($('#form-details').form('is valid')) {
        challenge.name = $scope.challenge.name;
        if ($('[name=\'goal\']').is(':visible')) {
          challenge.goal = $scope.challenge.goal;
        }
        if ($scope.challenge.prizes && $scope.challenge.prizes.length > 0) {
          challenge.prize = $scope.challenge.prizes;
        }
        if ($('[name=\'date-start\']').is(':visible')) {
          challenge.startDate = $scope.challenge.startDateMs;
        }
        if ($('[name=\'date-end\']').is(':visible')) {
          challenge.endDate = $scope.challenge.endDateMs;
        }

        challenge.challengeType = $scope.challenge.challengeType;
        challenge.recurring = $scope.challenge.recurring;
        challenge.participantType = $scope.challenge.participantType;
        challenge.winnerType = $scope.challenge.winnerType;

        // Optional parameters
        challenge.parameters = {
          'simple': $scope.savingsLevel,
          'percent_relief': $scope.percentageHomes
        };
        if ($scope.comment) {
          challenge.parameters.vtn_comment = $scope.comment;
        }

        // TODO: investigate
        //  Old code has a parameter: 'timeZone': utils.getBrowserTimezone()
        //  but server API docs has no data about such parameter
        return ChallengesService
          .updateChallenge($scope.orgInfo.id, $scope.challenge.challengeId, { 'challenge': challenge })
          .then(function(data) {
            let newChallenge = angular.merge($scope.challenge, challenge, {
              startDateMs: challenge.startDate,
              endDateMs: challenge.endDate
            });
            utils.setStorageItem('Selected-Challenge', newChallenge);
            ToastsService.success();
            return data;
          });
      }
    };

    $scope.saveChallenge = function(challenge) {
      if (challenge.type == '1300') {
        let promises = $scope.saveReportCard($scope.challenge);
        $q.all(promises).then(function(result) {
          if (result[0].resultCode == 0 && result[1].resultCode == 0) {
            $state.go('main.challenges.list');
          }
        });
      } else {
        updateChallenge();
      }
    };

    let getDeviceTypesPromise = DevicesService.getDeviceTypes();
    let getChallengePromise = ChallengesService.getChallenge($scope.orgInfo.id, $scope.challengeId);
    $q.all([getDeviceTypesPromise, getChallengePromise]).then(function(result) {
      let data0 = result[0];
      let data1 = result[1];
      if (data0.resultCode != 0 || data1.resultCode != 0) {
        return;
      }

      // Init Challenge
      $scope.challenge = data1.challenges[0];

      $scope.selectedTypeId = utils.getChallengeType($scope.challenge);
      $scope.savingsLevels = config.getConfigByKey('savingsLevels');
      // $scope.participantStatus = $scope.challenge.participantStatus;
      $scope.deviceTypeExistanceId = $scope.challenge.deviceTypeExistance;
      $scope.selectedDeviceTypeIds = $scope.challenge.deviceTypes;

      // Optional parameters
      if ($scope.challenge.parameters) {
        $scope.comment = $scope.challenge.parameters.vtn_comment || '';
        $scope.percentageHomes = $scope.challenge.parameters.percent_relief || 25;
        $scope.savingsLevel = parseInt($scope.challenge.parameters.simple) || 3;
      }
      if (!$scope.savingsLevel) {
        $scope.savingsLevel = 0;
      }

      let deviceTypes = [];
      for (let type of data0.deviceTypes) {
        for (let typeId of $scope.selectedDeviceTypeIds) {
          if (typeId == type.id) {
            deviceTypes.push(type);
          }
        }
      }
      $scope.selectedDeviceTypeObjs = deviceTypes;

      if ($scope.selectedTypeId == '1400') {
        $state.go('main.challenges.demand.more', {}, { location: false });
      }

      // Init Device Types
      if ($scope.orgInfo.deviceTypes == null || $scope.orgInfo.deviceTypes == '') {
        $scope.deviceTypes = data0.deviceTypes;
      } else {
        let types = $scope.orgInfo.deviceTypes.split(',');
        $scope.deviceTypes = utils.convertKeysToItems(data0.deviceTypes, types, 'id');
      }

    });


  }
}

export default angular
  .module('main.challengesDemand.controller', [])
  .controller('ChallengesDemandController', ChallengesDemandController)
  .name;
